module.exports = __webpack_public_path__ + "static/client-43f8d45ecbf688a32d11093e9b9fbef8.png";